import { regex } from './common'
export default regex('legalEntity', /^[a-zA-Z_]{1,60}$/)